<section class="init-screen">
  <pos-header [isLogoHeader]="true" [headerClass]="'init-header'"></pos-header>

  <div class="init-body" cdk-scrollable>
    <div class="init-card">
      <ng-container [ngSwitch]="currentState">
        <ng-container *ngSwitchCase="'ASK_LO'">
          <form [formGroup]="form">
            <div class="form-group">
              <label class="init-card-header">
                <label class="form-label text-center m-0">Are you already working with one of our loan officers?</label>
                <span></span>
              </label>

              <div class="custom-lg-control">
                <div class="form-group" ngbRadioGroup formControlName="isLoanOfficer">
                  <div class="checkbox-toggler-wrapper">
                    <label class="checkbox-toggler">
                      <input type="radio" [value]="true" formControlName="isLoanOfficer">
                      <span>Yes</span>
                    </label>
                    <label class="checkbox-toggler">
                      <input type="radio" [value]="false" formControlName="isLoanOfficer">
                      <span>No</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ng-container>
        <ng-container *ngSwitchCase="'CHOOSE_LO'">
          <form [formGroup]="form">
            <div class="form-group">
              <div class="init-card-header">
                <a class="back" (click)="appStates.ASK_LO.eligible && back()">
                  <ng-container *ngIf="appStates.ASK_LO.eligible">
                    <svg class="icon">
                      <use xlink:href="" [xlinkHref]="'#icon-select-input-arrow'"></use>
                    </svg>
                    Back
                  </ng-container>
                </a>
                <label class="form-label text-center m-0">Who is the loan officer?</label>
                <span></span>
              </div>

              <div class="custom-lg-control">
                <div class="form-group">
                  <div class=" prefix-suffix">
                    <span class="prefix lg">
                      <svg class="icon xlg fill-current text-muted">
                        <use xlink:href="#search"></use>
                      </svg>
                    </span>
                    <input type="text" class="form-control max-width-500" placeholder="Search Loan Officer"
                           formControlName="loanOfficer" autocomplete="nope" maxlength="100"
                           (keyup)="searchLoanOfficer($event)"
                           [appAutocomplete]="autocomplete"
                           (optionSelected)="loanOfficerSelected($event)"/>

                    <span *ngIf="loanOfficer.invalid && loanOfficer.touched" class="help-text invalid">
                      Loan officer is required
                    </span>
                  </div>
                  <app-autocomplete #autocomplete="appAutocomplete">
                    <ng-template appAutocompleteContent>
                      <ng-container *ngIf="(options) as result">
                        <app-option *ngFor="let option of result" [value]="option.name" [rowData]="option">
                          <span class="initials">{{option.initials}}</span>
                          <div class="details">
                            <span>{{option.name}}</span>
                            <small>{{option.email}}</small>
                          </div>
                        </app-option>
                        <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
                      </ng-container>
                    </ng-template>
                  </app-autocomplete>
                </div>

                <button [disabled]="!leadAssigneeId" class="continue-btn"
                        (click)="continue()">
                  Continue
                </button>
              </div>
            </div>
          </form>
        </ng-container>
      </ng-container>
    </div>
    <app-logout></app-logout>
  </div>
  <app-footer></app-footer>
</section>
